var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcAddFriendDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "14px",
    viewBox: "0 0 16 14",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icAddFriendDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Profile",
    transform: "translate(-224.000000, -1120.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Friends",
    transform: "translate(120.000000, 952.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UI/Buttons/Add-as-Friend-Desktop",
    transform: "translate(88.000000, 159.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icAddFriendDesktop",
    transform: "translate(16.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.7947759,4.18182856 L12.8530228,4.18182856 L12.8530228,2.05807034 C12.8530228,1.45171554 12.4036319,0.96 11.8490566,0.96 C11.2944813,0.96 10.8450904,1.45171554 10.8450904,2.05807034 L10.8450904,4.18182856 L8.90333728,4.18182856 C8.34876195,4.18182856 7.89937107,4.6735441 7.89937107,5.27989891 C7.89937107,5.88625371 8.34876195,6.37796925 8.90333728,6.37796925 L10.8450904,6.37796925 L10.8450904,8.50192966 C10.8450904,9.10828446 11.2944813,9.6 11.8490566,9.6 C12.4036319,9.6 12.8530228,9.10828446 12.8530228,8.50192966 L12.8530228,6.37817144 L14.7947759,6.37817144 C15.3493513,6.37817144 15.7987421,5.8864559 15.7987421,5.28010109 C15.7987421,4.6735441 15.3493513,4.18182856 14.7947759,4.18182856 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.72146698,4.8 L5.15274685,4.8 C6.12021251,4.8 6.91194969,3.93485184 6.91194969,2.87732312 L6.91194969,1.92251562 C6.91194969,0.865148156 6.12036005,0 5.15274685,0 L4.72146698,0 C3.75400133,0 2.96226415,0.865148156 2.96226415,1.92251562 L2.96226415,2.87732312 C2.9624117,3.93485184 3.75400133,4.8 4.72146698,4.8 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.835462,6.72 L2.05098453,6.72 C0.920158347,6.72 0,7.81640261 0,9.16402981 L0,12.6937455 C0,13.1059269 0.280371556,13.44 0.626295747,13.44 L8.26049671,13.44 C8.6064209,13.44 8.88679245,13.1059269 8.88679245,12.6937455 L8.88679245,9.16402981 C8.88679245,7.81640261 7.96663411,6.72 6.835462,6.72 Z",
    id: "Shape"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAddFriendDesktop);
export default __webpack_public_path__ + "static/media/icAddFriendDesktop.1fe358240216ae208e41fd9deec59630.svg";
export { ForwardRef as ReactComponent };